<template>
  <div style="background: #fafafa;min-height: 100vh">
    <div class="tishi">国家卫健委要求，就医行为必须实名登记</div>
    <div class="patient-list">
      <div class="patient-item font-85">
        <label>姓名</label>
        <div class="flex-s-c">
          <input type="text" v-model="name" placeholder="请输入真实姓名" />
        </div>
      </div>
      <div class="patient-item">
        <label>身份证号</label>
        <div class="flex-s-c">
          <input
            type="text"
            v-model="idCard"
            placeholder="请输入身份证号码"
            @input="inputidcard"
            @blur="inputidcard"
            max-length="18"
          />
        </div>
      </div>

      <div class="patient-item" v-show="sex!=''">
        <label>性别</label>
        <div class="flex-s-c">
          <input type="text" v-model="sex" readonly disabled />
        </div>
      </div>
      <div class="patient-item" v-show="age!=''">
        <label>年龄</label>
        <div class="flex-s-c">
          <input type="text" v-model="age" readonly disabled />
        </div>
      </div>
    </div>

    <div class="patient-list">
      <div class="patient-item">
        <label>关系</label>
        <span class="check-box" @click="changeRelation(1)" :class="{active:relation == 1}">本人</span>
        <span class="check-box" @click="changeRelation(2)" :class="{active:relation == 2}">父母</span>
        <span class="check-box" @click="changeRelation(3)" :class="{active:relation == 3}">爱人</span>
        <span class="check-box" @click="changeRelation(4)" :class="{active:relation == 4}">子女</span>
        <span class="check-box" @click="changeRelation(5)" :class="{active:relation == 5}">其他</span>
      </div>
      <div class="patient-item">
        <label>联系电话</label>
        <div class="flex-s-c">
          <input type="text" placeholder="请输入联系电话" v-model="telphone" />
        </div>
      </div>
    </div>

    <p class="queren">请确认患者信息真实准确，一经添加将无法修改</p>
    <div class="bottom" v-show="hideshow">
      <div class="checks">
        <i class="icon icon-check" :class="{'icon-checked':tongyi == 1}" @click="xieyi"></i>
        <p>
          开始问诊即代表您已阅读并同意
          <span
            style="color:rgba(24,144,255,1)"
            @click="handlePdf(1)"
          >《用户注册协议》(包含互联网诊疗风险告知及知情同意书)</span>及
          <span style="color:rgba(24,144,255,1)" @click="handlePdf(2)">《法律声明与隐私政策》</span>
        </p>
      </div>
      <div class="btns">
        <button class="submit-btn" @click="submitPat">确认添加并认证</button>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../request/http";

export default {
  name: "add_patient",
  data() {
    return {
      name: "",
      idCard: "",
      sex: "",
      relation: "",
      birthday: "",
      telphone: "",
      age: "",
      tongyi: 1,
      id: "",
      reg: /^[\u4E00-\u9FA5\·\.\-]+$/gi,
      docmHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      showHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      hideshow: true,
      is_pdf:false
    };
  },
  components: {},
  watch: {
    //监听显示高度
    showHeight: function () {
      if (this.docmHeight > this.showHeight) {
        //隐藏
        this.hideshow = false;
      } else {
        //显示
        this.hideshow = true;
      }
    },
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.showHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
      })();
    };
    this.id = this.$route.query.id;
    if (this.id) {
      this.patinfo();
    }
    let patient_data = sessionStorage.getItem('patient_data');
    if(patient_data && patient_data!='null'){
      patient_data = JSON.parse(patient_data);
      this.name = patient_data.name;
      this.idCard = patient_data.idCard;
      this.sex = patient_data.sex;
      this.age = patient_data.age;
      this.relation = patient_data.relation;
      this.telphone = patient_data.telphone;
    }
  },
  methods: {
    handlePdf(type) {
      this.is_pdf = true;
      let patient_data = {
        name:this.name,
        idCard:this.idCard,
        sex:this.sex,
        age:this.age,
        relation:this.relation,
        telphone:this.telphone,
      }
      sessionStorage.setItem('patient_data',JSON.stringify(patient_data))
      let pdf = "";
      if (type == 1) {
        pdf = "user_register_protocol.pdf";
      } else if (type == 2) {
        pdf = "legal_notice.pdf";
      }
      this.$router.push({
        name: "pdf_template",
        query: {
          pdf: pdf,
        },
      });
    },
    patinfo() {
      http
        .post("/api/wap/user/patientinfo", {
          pid: this.id,
        })
        .then((res) => {
          console.log(res);
          this.name = res.data.realname;
          this.idCard = res.data.idcard;
          res.data.sex == 1 ? (this.sex = "男") : (this.sex = "女");
          this.age = res.data.age;
          this.telphone = res.data.telphone;
          this.relation = res.data.relation;
        });
    },
    inputidcard() {
      if (this.idCard.length >= 18) {
        http
          .post("/api/wap/user/getmessage", {
            idcard: this.idCard,
          })
          .then((res) => {
            if (res.errno != 0) {
              this.$toast.center(res.errmsg);
            } else {
              this.age = res.data.age;
              if (res.data.sex == 1) {
                this.sex = "男";
              } else {
                this.sex = "女";
              }
            }
          });
      }
    },
    xieyi() {
      if (this.tongyi == 1) {
        this.tongyi = 2;
      } else {
        this.tongyi = 1;
      }
    },
    changeSex(sex) {
      this.sex = sex;
    },
    changeRelation(rel) {
      this.relation = rel;
    },
    submitPat() {
      this.reg = /^[\u4E00-\u9FA5\·\.\-]+$/gi;
      let sex = "";
      if (this.sex == "男") {
        sex = 1;
      } else {
        sex = 2;
      }
      if (this.tongyi == 1) {
        if (!this.reg.test(this.name)) {
          this.$toast.center("请填写真实姓名");
          return;
        }
        if (!this.idCard) {
          this.$toast.center("请填写身份证号码");
          return;
        }
        if(!this.relation){
          this.$toast.center("请选择就诊人的关系");
          return;
        }
        http
          .post("/api/wap/user/patientedit", {
            id: this.id ? this.id : "",
            realname: this.name,
            sex: sex,
            birthday: this.birthday,
            telphone: this.telphone,
            idcard: this.idCard,
            default: 1,
            relation: this.relation,
          })
          .then((res) => {
            console.log(res);
            if (res.errno != 0) {
              this.$toast.center(res.errmsg);
            } else {
              this.$toast.center("添加成功");
              this.$router.push({
                name: this.$route.query.from,
                query: this.$route.query,
              });
            }
          });
      } else {
        this.$toast.center("请勾选协议");
      }
    },
  },
  destroyed(){
    if(!this.is_pdf){
      sessionStorage.setItem('patient_data',null)
    }
  }
};
</script>

<style scoped>
.check-box.active {
  background: #e2e2e2;
}
.add-pat-btn {
  width: 100%;
  height: 2rem;
  margin-bottom: 2rem;
}
.tishi {
  width: 100%;
  height: 2.2rem;
  line-height: 2.2rem;
  background: #fff7e6;
  padding: 0 1rem;
  font-size: 0.6rem;
  color: #d46b08;
}
.check-box {
  width: 2.3rem;
  height: 1.5rem;
  text-align: center;
  line-height: 1.5rem;
  border: 0.05rem solid rgba(217, 217, 217, 1);
  border-radius: 0.25rem;
  font-size: 0.7rem;
}
.check-box.active {
  background: #1890ff;
  border: none;
  color: #fff;
}
.queren {
  margin-top: 0.8rem;
  font-size: 0.6rem;
  text-align: center;
  color:rgba(0,0,0,0.25);
}
.submit-btn {
  margin: 0;
  width: 17rem;
}
.checks p {
  width: calc(100% - 1.1rem);
}
.patient-item {
  height: 2.85rem;
  line-height: 2.85rem;
  display: flex;
  align-items: center;
}
.patient-item label {
  height: 2.8rem;
  line-height: 2.8rem;
  font-size: 0.8rem;
}
.patient-item div {
  width: calc(100% - 3.8rem);
  height: 2.8rem;
  line-height: 2.8rem;
}
.patient-item input {
  height: 2.8rem;
  line-height: 1.2rem;
  font-size: 0.8rem;
  width: 100%;
  border: none; /*去除边框*/
  -webkit-appearance: none; /*常用于IOS下移除原生样式*/
  outline: none;
  display:table-cell;
  vertical-align:middle;
  text-align:left;
  padding:0.8rem 0;
}
.flex-s-c {
  overflow: hidden;
  position: relative;
  display:table;
}
.patient-item input::-webkit-input-placeholder{
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.8rem;
  transform: translate(0, 0.06rem);
}
.patient-item input:-moz-placeholder{
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.8rem;
  transform: translate(0, 0.06rem);
}
.patient-item input::-moz-placeholder{
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.8rem;
  transform: translate(0, 0.06rem);
}
.patient-item input:-ms-input-placeholder{
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.8rem;
  transform: translate(0, 0.06rem);
}
</style>



// WEBPACK FOOTER //
// src/pages/patient/patient_edit.vue